import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Carregando...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-content">
        <div className="logo-spinner">
          <img 
            src="/assets/images/logo-halo.webp" 
            alt="Halo Logo" 
            className="spinning-logo"
          />
        </div>
        <h3 className="loading-message">{message}</h3>
      </div>
    </div>
  );
};

export default LoadingSpinner;
